import React, { useEffect, useRef, useState } from "react";
import ss from "./Teamsetup.module.css";
import classNames from "classnames";
import {
  apiRequest,
  showLoading,
  showAlert,
  rem2px,
  PLAYER_URL_PREFIX,
  // API_SERVER_URL,
} from "../../utils";

export default function Teamsetup(props) {
  const { clone, team } = props;

  const [name, setName] = useState(""); //队伍名称

  const [name_input, setName_input] = useState(false); // 名称可输入状态

  const [name_active, setName_active] = useState(false); // 队名确认

  const [evengy_active, setEvengy_active] = useState(false); //能量确认
  const [extractEnergy, setExtractEnergy] = useState(0);

  const [password, setpasword] = useState(false); //登录码确认

  const fadeoutPopup = () => {
    const signOut = document.getElementById("signOut");
    const block = document.getElementById("block");
    block.classList.add(ss.Blockfadeout);
    signOut.classList.add(ss.fadeoutEff);
    setTimeout(() => {
      clone();
    }, 600);
  };

  const exit = () => {
    fadeoutPopup();
  };

  useEffect(() => {
    if (team.name) {
      setName(team.name);
      setName_active(false);
      setEvengy_active(true);
      password_confirm();
    } else {
      setName_active(true);
    }
  }, [team.name]);

  useEffect(() => {
    if (team.has_extract_energy) {
      setName_input(true);
      const loading = showLoading("加载中");
      apiRequest("/get_initial_energy", "GET", { team_uuid: team.uuid })
        .then((res) => {
          if (res.code === 0) {
            setExtractEnergy(res.energy);
            const energy_txt = document.getElementById("energy_txt");
            const energy = document.getElementById("energy");
            energy_txt.style.opacity = 0;
            energy.style.opacity = 1;
            setEvengy_active(false);
            const QR = document.getElementById("qrcode");
            const dis_txt = document.getElementById("dis_txt2");
            dis_txt.style.opacity = 0;
            QR.style.opacity = 1;
            setpasword(false);
          } else showAlert(res.msg);
        })
        .catch((err) => console.log(err))
        .finally(() => loading.hide());
    } else {
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [team.has_extract_energy]);

  // 确认队名
  const name_confirm = () => {
    if (!name_active) return;
    if (name_input) return;
    if (!name || name.length === 0) {
      showAlert("请输入队伍名称");
      return;
    }
    const loading = showLoading("加载中");
    apiRequest("/set_team_name", "POST", {
      team_uuid: team.uuid,
      name,
    })
      .then((res) => {
        if (res.code === 0) {
          setName_input(true);
          setEvengy_active(true);
          setName_active(false);
          setpasword(true);
        } else showAlert(res.msg);
      })
      .catch((err) => console.log(err))
      .finally(() => loading.hide());
  };

  //抽取能量值
  const energy = () => {
    if (!evengy_active) return;
    const loading = showLoading("加载中");
    apiRequest("/extract_energy", "POST", { team_uuid: team.uuid })
      .then((res) => {
        if (res.code === 0) {
          setExtractEnergy(res.energy);
          const energy_txt = document.getElementById("energy_txt");
          const energy = document.getElementById("energy");
          energy_txt.style.opacity = 0;
          setTimeout(() => {
            energy.style.opacity = 1;
          }, 0.5 * 1000);
          setEvengy_active(false);
          setpasword(true);
        } else showAlert(res.msg);
      })
      .catch((err) => console.log(err))
      .finally(() => loading.hide());
  };

  // 登录码
  const password_confirm = () => {
    // if (!password) return;
    const QR = document.getElementById("qrcode");
    const dis_txt = document.getElementById("dis_txt2");
    dis_txt.style.opacity = 0;
    setTimeout(() => {
      QR.style.opacity = 1;
    }, 0.5 * 1000);
    setpasword(false);
  };

  // 加入二维码
  const drawQRCode = (team_uuid) => {
    const qrcodeEle = document.getElementById("qrcode");
    window.QRCode &&
      new window.QRCode(qrcodeEle, {
        text: `${PLAYER_URL_PREFIX}/join?tid=${team_uuid}`,
        width: rem2px(800),
        height: rem2px(800),
        colorDark: "#111",
        colorLight: "#fff",
        correctLevel: window.QRCode.CorrectLevel.H,
      });
  };
  const hasDraw = useRef(false);
  useEffect(() => {
    if (hasDraw.current) return;
    hasDraw.current = true;
    // load qrcode js
    const script = document.createElement("script");
    script.src = "/js/qrcode.min.js";
    script.async = false; // 可选，设置为true使脚本异步加载
    document.body.appendChild(script);
    script.onload = () => {
      drawQRCode(team.uuid);
    };
    return () => {
      document.body.removeChild(script);
    };
  }, [team.uuid]);

  return (
    <div className={ss.bg}>
      <div className={ss.signOut}>
        <div className={ss.black} id="block"></div>
        <div className={ss.tooltip} id="signOut">
          <div
            className={ss.X}
            onClick={() => {
              exit();
            }}
          ></div>
          <div className={ss.disposition}>
            <div className={ss.box}>
              <div className={classNames(ss.disposition_box, ss.name)}>
                <img
                  className={ss.avatar}
                  src={require(`../../components/Avatar/img/color${team.color}.png`)}
                  alt=""
                />
                <input
                  className={ss.input_box}
                  disabled={name_input}
                  type="text"
                  value={name}
                  placeholder={"请设置队名"}
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                />
              </div>
              <div
                className={classNames(ss.btn, name_active && ss.btn_active)}
                onClick={() => {
                  name_confirm();
                }}
              >
                确认
              </div>
            </div>
            {/* <div className={ss.box}>
              <div className={ss.disposition_box}>
                <span id="energy">{extractEnergy}点</span>
                <div id="energy_txt" className={ss.dis_txt}>
                  初始能量值
                </div>
              </div>
              <div
                className={classNames(ss.btn, evengy_active && ss.btn_active)}
                onClick={() => energy()}
              >
                抽取
              </div>
            </div> */}
            <div className={ss.box}>
              <div className={ss.disposition_box}>
                <div className={ss.QR} id="qrcode"></div>
                <div className={ss.dis_txt2} id="dis_txt2">
                  设置登录码
                </div>
              </div>
              <div
                className={classNames(ss.btn, password && ss.btn_active)}
                onClick={() => {
                  password_confirm();
                }}
              >
                设置
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
